import React, { createContext, useContext } from 'react'

import useElections, { ElectionsHook } from '@/hooks/useElections'

interface ElectionsContextProps extends ElectionsHook {}

const ElectionsContext = createContext<ElectionsContextProps | undefined>(undefined)

export const ElectionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const electionsData = useElections()

  return <ElectionsContext.Provider value={electionsData}>{children}</ElectionsContext.Provider>
}

export const useElectionsContext = (): ElectionsContextProps => {
  const context = useContext(ElectionsContext)
  if (!context) {
    throw new Error('useElectionsContext must be used within an ElectionsProvider')
  }
  return context
}
